import { createFileRoute } from '@tanstack/react-router'
import { PinnedReportsView } from '@/components/reports/PinnedReportsView'

/**
 * New design: Reports section (Pinned Reports)
 */
export const Route = createFileRoute('/_app/reports')({
  component: PinnedReportsView,
})
